import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { LoginTabMethod } from '../LoginTabMethod';
import { AuthButton } from '../../../common/Button/AuthButton/AuthButton';
import { SignInFormProps } from './types';

export const SignInForm: React.FC<SignInFormProps> = ({
  formik,
  handleChangePhone,
  handleGoogleAuth,
  loadingAuthButton,
  stopLoadingButtonStatus,
}) => {
  const { t } = useTranslation();
  const { values, errors, touched, handleChange, setFieldTouched } = formik;
  const [, setActiveTab] = useState('1'); // '1' = phone, '2' = email

  return (
    <>
      <LoginTabMethod
        errors={errors}
        handleChange={handleChange}
        handleChangePhone={handleChangePhone}
        setFieldTouched={setFieldTouched}
        touched={touched}
        values={values}
        onTabChange={setActiveTab}
      />



      <AuthButton
        text={t('userAuth.signInViaGoogleBtnText')}
        onClick={handleGoogleAuth}
        loading={!stopLoadingButtonStatus && loadingAuthButton}
      />
    </>
  );
};
